import React, { useEffect, useState } from 'react';
import { FiChevronUp } from 'react-icons/fi';

const ScrollTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisible = () => setVisible(document.documentElement.scrollTop > 300);
        toggleVisible();
        window.addEventListener('scroll', toggleVisible, { passive: true });
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <button
            type="button"
            className="rn-back-top"
            onClick={scrollToTop}
            style={{ display: visible ? 'inline-flex' : 'none' }}
            aria-label="Przewiń do góry"
        >
            <FiChevronUp />
        </button>
    );
};

export default ScrollTop;
